//src/pages/REG/REG410F1.jsx
import React, {useContext, useEffect, useRef, useState} from 'react';
import style from "./REG410F1.module.scss";
import toast from "components/Toast/Toast";
import Button from "components/Button/Button";
import SwitchGroup from "components/Button/SwitchGroup"
import InputUnitText from "components/InputText/InputUnitText";
import Table from "components/Table/Table";
import DatePicker from "components/DatePicker/DatePicker";
import {dateToYMD, ymdToDate} from './REGComUtil'; //
import {postData} from 'utils/TransactionUtil';
import {AuthContext} from "contexts/AuthContext";

//import ConfirmModal from "./REG100M1";
import styleCom from "./REGCOM.module.scss";
import * as XLSX from "xlsx";
import DataGrid from "../../components/DataGrid/DataGrid";
import SelectBox from "../../components/SelectBox/SelectBox";


// 페이지 시작
const REG410F1 = ({navBar: NavBar}) => {

    const authContext = useContext(AuthContext);
    const userInfo = authContext.userInfo; // 사용자 정보 가져오기
    const [comHsptObj, setComHsptObj] = useState([]);
    const [itemHsptCd, setItemHsptCd] = useState([]);
    const [isDisabledHspt, setIsDisabledHspt] = useState(false);


    //form load
    useEffect(() => {
        getComDtlsData(); //공통코드 조회
    }, []);
    /*  ****************************************************************************** */

    const [rows_excel, setRows_excel] = useState([]);
    const cols_excel = [
         { key: '등록번호', name: '등록번호',   width: '10%' }
        ,{ key: '일시',    name: '등록일시',   width: '10%' }
        ,{ key: 'sbp',    name: 'SBP(mmHg)', width: '20%' }
        ,{ key: 'dbp',    name: 'DBP(mmHg)', width: '20%' }
        ,{ key: 'mbp',    name: 'MBP(mmHg)', width: '20%' }
        ,{ key: 'pulse',  name: 'Pulse',     width: '20%' }
    ];
    const [convertExcel, setConvertExcel] = useState([]);


    /* EVENT ****************************************************************************** */
    const buttonClick_uploadBulkCartBp = () => {
        const resultHsptNm = comHsptObj.find(item => item.comnDtlsCd === itemHsptCd)?.detlCdNm;
        const confirmed = window.confirm('선택하신곳 기준으로 업로드 하시겠습니까?\n  '+ '[ '+resultHsptNm+' ]');

        if(isFileCheck){
            if (confirmed) {
                svcUploadBulkCartBp().then(() => {
                    toast({ type: 'info', message: '저장되었습니다.', opt: { position: "top-center"} });
                });
            }
        }else{
            toast({ type: 'warning', message: '업로드 데이터를 확인하여 주십시오.', opt: { position: "top-center"} });
        }

    }

    //파일찾기 초기화
    const buttonClick_fileReset = () => {
        fileReset();
    }
    const fileReset = () => {
        setIsFileCheck(false);
        setConvertExcel([]);
        setRows_excel([]);
        setIsDisabledHspt(false);
    }

    /* 파일업로드 처리 ****************************************************************************** */
    const [isFileCheck, setIsFileCheck] = useState(false);
    const fileInputRef = useRef(null);

    // 1. 버튼 클릭 → 파일 탐색기 열기
    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    // 2. 파일 선택 → 엑셀 읽고 JSON 변환
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (event) => {
            const arrayBuffer = event.target.result;
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);

            if (jsonData.length === 0) {
                alert('❌ 파일에 데이터가 없습니다.');
                e.target.value = ''; // 초기화
                return;
            }

            // 기존 데이터 초기화
            setRows_excel([]);     //그리드 
            setIsFileCheck(false); //체크로직 통과여부

            // 필수 헤더 체크
            const requiredFields = ['등록번호', '일시', 'dbp', 'sbp', 'mbp', 'pulse'];
            const headers = Object.keys(jsonData[0]);
            const missingFields = requiredFields.filter(field => !headers.includes(field));

            if (missingFields.length > 0) {
                alert(`❌ 다음 필드들이 누락되었습니다:\n[${missingFields.join(', ')}]`);
                e.target.value = ''; // 초기화
                return;
            }

            // 데이터 유효성 검사
            const hasValidationError = jsonData.some((row, index) => {
                const rowNum = index + 2; // 엑셀에서 헤더는 1행
                const { 등록번호, 일시, sbp, dbp, mbp, pulse } = row;

                // 필수 텍스트 필드 검사
                const requiredTextFields = { 등록번호, 일시 };
                for (const [key, value] of Object.entries(requiredTextFields)) {
                    if (!value || value === '') {
                        alert(`❌ ${rowNum}번째 행: [${key}] 값이 없습니다.`);
                        return true;
                    }
                }

                // 숫자 필드 검사
                const numericFields = { sbp, dbp, mbp, pulse };
                for (const [key, value] of Object.entries(numericFields)) {
                    if (isNaN(value)) {
                        alert(`❌ ${rowNum}번째 행: [${key}] 값이 숫자가 아닙니다. 현재 값: ${value}`);
                        return true;
                    }
                }

                return false;
            });

            if (hasValidationError) {
                setIsDisabledHspt(false); //기관선택 버튼 활성화
                e.target.value = ''; // 초기화
                return;
            }

            // 유효한 데이터 저장
            setRows_excel(jsonData);
            setIsFileCheck(true)
            setIsDisabledHspt(true);  //기관선택 버튼 비활성화
            setConvertExcel(
                jsonData.map(row => {
                    const { 등록번호, 일시, ...rest } = row;
                    return {
                        studyPid: 등록번호,
                        cartDt: 일시,
                        ...rest,
                        hsptCd:itemHsptCd
                    }
                })
            );


            // 같은 파일 다시 선택 가능하게 초기화
            e.target.value = '';
        };

        reader.readAsArrayBuffer(file);
    };

/* Call Service ****************************************************************************** */
    //공통정보 조회
    async function getComDtlsData() {
        //공통 기관정보
        const param1 = {comGrpCd:"HSPT_CD"}
        const resultData1 = await postData("/getComDtlsCd", param1);
        setComHsptObj(resultData1);
        setItemHsptCd(userInfo.hsptCd);
    }

    async function svcUploadBulkCartBp() {
        let result = await postData("/RED/uploadBulkCartBp", convertExcel);
    }

///////////////////////////////

    return (
        <>
            {/*메인 영역*/}
            <div className={styleCom.root_wrap}>
                <div className={styleCom.main_wrap}>
                    <div className={styleCom.title_wrap} style={{marginTop: "10px", marginBottom: '-10px'}}>
                        <h3>데이터 업로드</h3>
                    </div>
                    <Table variant='default' rowCnt={1} colSize={['20%', '30%', '15%', '35%']} rowSize={'70px'}>
                        <div><h2>📁 엑셀파일 찾기(CART BP)</h2></div>
                        <div>
                            <SelectBox options={comHsptObj} value={itemHsptCd}
                                       width={180}
                                       onChange={(value) => setItemHsptCd(value)}
                                       isAllExpr={false} isDisabled={isDisabledHspt} />
                            <Button variant="Tertiary" size="md" addStyle={{width: "180px", height: "40px"}}
                                    onClick={() => handleButtonClick()}>
                                Select Excel File
                            </Button>
                            <Button variant="Secondary" size="md" addStyle={{width: "80px", height: "40px"}}
                                    onClick={() => buttonClick_fileReset()}>
                                초기화
                            </Button>
                            <input
                                type="file"
                                accept=".xlsx, .xls"
                                ref={fileInputRef}
                                style={{display: 'none'}}
                                onChange={handleFileChange}
                            />
                        </div>
                        <div><h2>📤 데이터 업로드 </h2></div>
                        <div>
                            <Button variant="Primary" size="md" addStyle={{width: "150px", height: "50px"}}
                                    onClick={() => buttonClick_uploadBulkCartBp()}>
                                Upload data
                            </Button>
                            {isFileCheck?"✔️ 업로드가 가능합니다.":"✖️ 업로드 데이터를 확인하여 주십시오."}
                        </div>
                    </Table>
                    <div className={styleCom.title_wrap} style={{marginTop: "10px", marginBottom: '-20px'}}>
                        <h3>Preview Data </h3>
                    </div>
                    <div style={{marginTop: "10px"}}>
                        <DataGrid
                            cols={cols_excel}
                            rows={rows_excel}
                            rowHeight={37}
                            // onCellDoubleClick={(e) => handleDoubleClick_DataGrid_row(e)}
                            sortable={true}
                            isNodataView={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};


export default REG410F1;
